import "./App.css";
import "./fonts/stylesheet.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./Home";
import Header from "./components/Header/Index";
import Footer from "./components/Footer/Index";
import Undermaintaince from "./components/Undermaintaince/Index";
import ScrollToTop from "./ScrollToTop";
import Manufacturing from "./Manufacturing";
import Clients from "./Clients";
import Career from "./Career";
import Aboutus from "./Aboutus";
import Contact from "./Contact";
import ThankYouPage from "./ThankYouPage";
import Error from "./Error";
import Service from "./Service";
import GalleryPage from "./Gallerypage";
import Servicedetails from "./Servicedetails";
import Outsource from "./Outsource";
import ContentPage from "./ContentPage"
import Sustainibility from "./Sustainibility";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-united-corp" element={<Aboutus />} />
          <Route path="/our-services" element={<Service />} />
          <Route path="/our-services/:slug" element={<Servicedetails />} />          
          <Route path="/our-facility" element={<Manufacturing />} />
          <Route path="/our-clients" element={<Clients />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />          
          <Route path="/contact-us" element={<Contact />} />
           <Route path="*" element={<Error />} />
          <Route path="/under-construction" element={<Undermaintaince />} />
          <Route path="/:slug" element={<ContentPage />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}


export default App;
